module.exports = __webpack_public_path__ + "static/img/VIP_dark@2x.5ceea68.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/anniversary/VIP_dark@2x.png
// module id = gxPQ
// module chunks = 0